import React from 'react'
import { number, string } from 'prop-types'

import Inline from '@/component/Primitive/Inline'
import Tag from '@/component/Primitive/Tag'
import Type from '@/component/Primitive/Type'

import styles from './RankedListItem.module.scss'

const RankedListItem = ({ i, category, content }) => {
  return (
    <>
      <div className={styles.RankedListTags}>
        <Inline gap="small">
          <Tag themed>#{i + 1}</Tag>
          {category && <Tag>{category}</Tag>}
        </Inline>
      </div>
      <Type themed size="heading8" weight="bold">
        {content}
      </Type>
    </>
  )
}

RankedListItem.propTypes = {
  i: number,
  category: string,
  content: string
}

export default RankedListItem
